<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-button type="primary" icon="plus" @click="openDialog()">添加链接</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" :height="wheight-140" v-loading="loading">
        <el-table-column prop="id" label="链接id"></el-table-column>
        <el-table-column prop="title" label="名称"></el-table-column>
        <el-table-column prop="links" label="链接"></el-table-column>
        <el-table-column prop="description" label="描述"></el-table-column>
				<el-table-column label="是否启用">
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.is_open == '0'" >禁用</el-tag>
            <el-tag type="warning" v-else >启用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="100">
          <template slot-scope="scope">
						<a href="javascript:void(0)" @click="delPage(scope.row.id)">删除</a>
						<a href="javascript:void(0)" @click="openDialog(scope.row)">编辑</a>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="total_count > params.pageSize" class="content-padded content-center">
        <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :total="total_count" :page-size="params.pageSize">
        </el-pagination>
      </div>
      <el-dialog :title="dialogTitle" :visible.sync="page_dialog" :close-on-click-modal="false" :before-close="handleCancel">
        <el-form v-model="pageForm" label-width="200px">
          <el-form-item label="链接名称">
            <el-input v-model="pageForm.title" placeholder="链接名称" style="width: 55%;"></el-input>
          </el-form-item>
          <el-form-item label="链接地址">
            <el-input v-model="pageForm.links" placeholder="链接地址" style="width: 55%;"></el-input>
          </el-form-item>
	        <el-form-item label="描述">
            <el-input v-model="pageForm.description" placeholder="描述" style="width: 55%;"></el-input>
          </el-form-item>
					<el-form-item label="是否启用">
            <el-switch v-model="pageForm.is_open" > </el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer content-center">
          <el-button type="primary" @click="savePage">确认保存</el-button>
        </div>
      </el-dialog>
			<el-dialog :visible.sync="template_dialog" width="80%" title="编辑页面" fullscreen lock-scroll>
        <shopDecoration :id="pageForm.id" @saved="closeDialog" usage="page" :template_name="template_name"/>
      </el-dialog>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { getCustomLinkPageList, createCustomLinkPage, delCustomLinkPage, editCustomLinkPage } from '@/api/wxa'
  import shopDecoration from '@/components/function/shopDecoration'

  export default {
    components: {shopDecoration},
    data () {
      return {
        template_dialog: false,
        page_dialog: false,
        total_count: 0,
        dialogTitle: '新增链接',
        loading: false,
        params: {
          page: 1,
          pageSize: 20
        },
        pageForm: {
          id: '',
          title: '',
          links:'',
          description: '',
          is_open: true
        },
        list: []
      }
    },
    computed: {
      ...mapGetters([
        'wheight',
        'template_name'
      ])
    },
    methods: {
      temDialog (id, type) {
        this.pageForm.id = id
        this.template_dialog = true
      },
      closeDialog () {
        this.template_dialog = false
      },
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.fetchPageList()
      },
      delPage (id) {
        this.$confirm('确认删除当前页面吗？').then(_ => {
          delCustomLinkPage(id).then(res => {
            this.$message({ type: 'success', message: '操作成功！' })
            this.fetchPageList()
          })
        })
      },
      openDialog (detail = null) {
        this.page_dialog = true
        if (detail) {
          this.pageForm = detail
          if (detail.is_open == 1) {
            this.pageForm.is_open = true
          }
          this.dialogTitle = '编辑页面'
        } else {
          this.dialogTitle = '新增链接'
          this.pageForm = {id: '', title: '', links: '', description: '', is_open: true }
        }
      },
      savePage () {
        let {title,links, description, is_open, id} = this.pageForm
        const params = {title,links, description, is_open, template_name: this.template_name}
        if (this.dialogTitle == '编辑页面') {
          const params = {title,links, description, is_open,template_name: this.template_name}
          editCustomLinkPage(id, params).then(res => {
            console.log(res,11111);
            this.page_dialog = false
            this.fetchPageList()
            this.$message({
              type: 'success',
              message: '保存页面成功'
            })
          })
        }
        console.log(this.dialogTitle,26)
        if (this.dialogTitle == '新增链接') {
          createCustomLinkPage(params).then(res => {
            this.page_dialog = false
            this.fetchPageList()
            this.$message({
              type: 'success',
              message: '保存页面成功'
            })
          })
        }
      },
      fetchPageList () {
        this.loading = true
        Object.assign(this.params, {template_name: this.template_name})
        getCustomLinkPageList(this.params).then(response => {
          if (response.data.data.list) {
            this.list = response.data.data.list
            this.total_count = response.data.data.total_count
          }
          this.loading = false
        })
      },
      handleCancel () {
        this.page_dialog = false
      }
    },
    mounted () {
      this.fetchPageList()
    }
  }
</script>




// WEBPACK FOOTER //
// customlink.vue?d0c4b84a